import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const BrandingSharedDocuments = () => {
    return <SharedDocumentsComponent permissionId="34" path="Marca e Publicidade" />
}